<template>
  <!-- clase move creada para cambiar el cursor a move -->
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="tasks" />&nbsp; Configurar Quiz
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col lg="12">
          <b-form-group>
            <label for="name">No. de Preguntas</label>
            <b-form-select
              :value="defaultSelected"
              id="preguntasNumero"
              class="border-visible"
              :options="noPreguntas"
              @change="onChangePreguntas($event)"
              variant="primary"
            >
              <template slot="first">
                <option :value="null" disabled>Seleccione un Número</option>
              </template>
            </b-form-select>
          </b-form-group>

          <div v-for="(pregunta,index) in preguntasSelected" :key="index">
            <b-form-group>
              <p>
                <strong>Pregunta No. {{index + 1}}</strong>
                <span style="float: right; font-size: 19px;">
                  <i class="icon-close close-style" @click="removePregunta(index)"></i>
                </span>
              </p>
            </b-form-group>
            <div>
              <b-form-group>
                <label :for="`pregunta${index}${pregunta.id}`">Pregunta</label>
                <b-form-input
                  type="text"
                  :id="`pregunta${index}${pregunta.id}`"
                  placeholder="Ingresa la pregunta"
                  v-model="pregunta.pregunta"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label for="opcionesRespuestas">No. de opciones</label>
                <b-form-select
                  :value="defaultSelected"
                  id="opcionesRespuestas"
                  :options="[1,2,3,4]"
                  @change="onChangeOpciones($event, pregunta)"
                >
                  <template slot="first">
                    <option :value="null" disabled>Seleccione un número</option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-row class="form-group">
                <b-col sm="3" v-for="opcion in pregunta.opciones" :key="opcion.id">
                  <b-form-input
                    v-model="opcion.respuesta"
                    type="text"
                    :placeholder="`Opción ${opcion.id}`"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="form-group">
                <b-col
                  sm="3"
                  v-for="opcion in pregunta.opciones"
                  :key="opcion.id"
                  style="text-align:center;"
                >
                  <b-form-radio
                    :name="`opciones-respuestas${pregunta.id}`"
                    :value="false"
                    @change="triggerOpcion(opcion.id, pregunta.opciones)"
                  >Respuesta Correcta</b-form-radio>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
        <b-col lg="12" style="text-align: right;">
          <button type="button" class="btn btn-primary" @click="newPregunta">
            <i class="icon-plus"></i>&nbsp;Nueva Pregunta
          </button>
        </b-col>
      </b-row>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>

<script>
var arry = new Array(46);
var noPreguntas = [];
for (let i = 1; i < arry.length; i++) {
  noPreguntas.push(i);
}
import OptionsElement from "./OptionsElement";
export default {
  name: "QuizContent",
  components: { OptionsElement },
  data() {
    return {
      instrucciones: this.desc,
      defaultSelected: null,
      noPreguntas: noPreguntas,
      preguntasSelected: this.preguntas,
      previewActive: false
    };
  },
  props: {
    preguntas: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    idElement: { type: Number },
    idColumn: { type: Number, default: null },
    desc: { type: String }
  },
  methods: {
    onChangePreguntas(number) {
      this.preguntasSelected = [];
      var preguntasArry = new Array(number);
      for (let i = 0; i < preguntasArry.length; i++) {
        let preguntaData = {
          id: i + 1,
          pregunta: "",
          respuesta: "",
          opciones: []
        };
        this.preguntasSelected.push(preguntaData);
      }
    },
    onChangeOpciones(number, pregunta) {
      pregunta.opciones = [];
      var opcionesArry = new Array(number);
      for (let i = 0; i < opcionesArry.length; i++) {
        var opcionData = { id: i + 1, respuesta: "", isOk: false };
        pregunta.opciones.push(opcionData);
      }
    },
    triggerOpcion(id, opciones) {
      opciones.forEach(el => {
        if (el.id == id) {
          el.isOk = true;
        } else {
          el.isOk = false;
        }
      });
    },
    removePregunta(index) {
      this.$swal({
        type: "warning",
        title: "Eliminar una Pregunta",
        text: `¿Seguro que Deseas Eliminar la Pregunta No. ${index + 1}?`,
        showCancelButton: true,
        confirmButtonColor: "#285c4d",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "No, Cancelar"
      }).then(result => {
        if (result.value) {
          this.preguntasSelected.splice(index, 1);
        }
      });
    },
    newPregunta() {
      var i = this.preguntasSelected.length;
      var preguntaData = {
        id: i + 1,
        pregunta: "",
        respuesta: "",
        opciones: []
      };
      this.preguntasSelected.push(preguntaData);
    }
  },
  watch: {
    preguntasSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "preguntas",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>